/*
 * Palo Alto Theme
 *
 * Use this file to add custom Javascript to Palo Alto.  Keeping your custom
 * Javascript in this fill will make it easier to update Palo Alto. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

 (function () {


// CACHER MOT GRATUIT //

function hideOnlyFreeWord() {
  // Sélectionne tous les spans de total final (où apparaît "GRATUIT" ou un prix)
  document.querySelectorAll('.kaching-cart-item__total-final').forEach((el) => {
    const txt = el.textContent.trim().toUpperCase();
    
    // Si le texte est "GRATUIT", on le masque
    if (txt === "GRATUIT") {
      el.style.visibility = "hidden"; // rend invisible mais garde la place
      // el.style.display = "none"; // optionnel : retire totalement si tu veux
      console.log("🙈 Mot 'GRATUIT' masqué :", el);
    } else {
      // S'il y a un prix, on le laisse visible
      el.style.visibility = "visible";
      el.style.display = "";
    }
  });
}

// 🔁 Surveillance du panier (drawer ou page complète)
function observeFreeWord() {
  hideOnlyFreeWord();

  const drawer = document.querySelector("#cartItemsHolder") || document.body;
  const observer = new MutationObserver(() => hideOnlyFreeWord());
  observer.observe(drawer, { childList: true, subtree: true });

  console.log("👁️ Surveillance active : seul le mot 'GRATUIT' est masqué.");
}

// 🚀 Lancement automatique
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", observeFreeWord);
} else {
  observeFreeWord();
}


//   const bundleMap = {
//     /* FR - OG - COMBO PARFAIT ENCRE */
//     "6808ff84-3fcc-43f7-bb88-3ec897a68ef6": {
//       main: "53582894235979",
//       subs: [
//         // Encre à Lèvres
//         "53553910055243",
//         "53553910088011",
//         "53553910120779",
//         // Repulpeur Lèvres
//         "53555064537419",
//         "53555064570187",
//         "53555066798411",
//         "53555066831179",
//       ],
//     },

//     /* EUR - OG - COMBO PARFAIT ENCRE */
//     "30bc0339-3b9e-4db7-86a4-0f3d6ddeb63d": {
//       main: "53582894235979",
//       subs: [
//         "53553910055243",
//         "53553910088011",
//         "53553910120779",
//         "53555064537419",
//         "53555064570187",
//         "53555066798411",
//         "53555066831179",
//       ],
//     },

//     /* INT - OG - COMBO PARFAIT ENCRE */
//     "9d910e4f-4712-495c-9727-e384ed5af599": {
//       main: "53582894235979",
//       subs: [
//         "53553910055243",
//         "53553910088011",
//         "53553910120779",
//         "53555064537419",
//         "53555064570187",
//         "53555066798411",
//         "53555066831179",
//       ],
//     },
//     /* FR - OG - TRIPLE LIP PLUMPER EDITION ENCRE */
//     "a4b1783c-08a4-4631-b3b3-18cf6c4050c1": {
//       main: "53583350137163",
//       subs: [
//         // Encre à Lèvres
//         "53540501848395",
//         "53540501881163",
//         "53540501913931",
//         // Repulpeur Extrême
//         "53540501291339",
//         "53540501324107",
//         // Repulpeur Soft
//         "53540499521867",
//         "53540499554635",
//       ],
//     },

//     /* EUR - OG - TRIPLE LIP PLUMPER EDITION ENCRE */
//     "1701016a-9999-4d5c-b5a5-d9cad913aef2": {
//       main: "53583350137163",
//       subs: [
//         "53540501848395",
//         "53540501881163",
//         "53540501913931",
//         "53540501291339",
//         "53540501324107",
//         "53540499521867",
//         "53540499554635",
//       ],
//     },

//     /* INT - OG - TRIPLE LIP PLUMPER EDITION ENCRE */
//     "3b061744-f722-4551-80de-00eeee2d35f9": {
//       main: "53583350137163",
//       subs: [
//         "53540501848395",
//         "53540501881163",
//         "53540501913931",
//         "53540501291339",
//         "53540501324107",
//         "53540499521867",
//         "53540499554635",
//       ],
//     },
//     /* FR - OG - COMBO PARFAIT REPULPEUR */
//     "1d087ea6-9e1c-4b58-91d3-84e6cbfa9093": {
//       main: "53558463496523",
//       subs: [
//         // Repulpeur Lèvres Extrême
//         "53555064537419",
//         "53555064570187",
//         "53555066798411",
//         "53555066831179",
//         // Encre à Lèvres Longue Tenue
//         "53553910055243",
//         "53553910088011",
//         "53553910120779",
//       ],
//     },

//     /* EUR - OG - COMBO PARFAIT REPULPEUR */
//     "9a584be8-c05d-4d19-8366-84d5b6be407d": {
//       main: "53558463496523",
//       subs: [
//         "53555064537419",
//         "53555064570187",
//         "53555066798411",
//         "53555066831179",
//         "53553910055243",
//         "53553910088011",
//         "53553910120779",
//       ],
//     },

//     /* INT - OG - COMBO PARFAIT REPULPEUR */
//     "03f356c3-54ba-46e8-8dc2-9ac6ece4d081": {
//       main: "53558463496523",
//       subs: [
//         "53555064537419",
//         "53555064570187",
//         "53555066798411",
//         "53555066831179",
//         "53553910055243",
//         "53553910088011",
//         "53553910120779",
//       ],
//     },
//     /* FR - OG - TRIPLE LIP PLUMPER EDITION REPULPEUR*/
//     "874e24aa-63f8-49d4-aa75-2e5e4f1b8bfe": {
//       main: "53583326806347",
//       subs: [
//         // Encre à Lèvres Peel-Off – Trio
//         "53540501848395",
//         "53540501881163",
//         "53540501913931",
//         // Repulpeur Lèvres Extrême – Trio
//         "53540501291339",
//         "53540501324107",
//         // Repulpeur Lèvres Soft – Trio
//         "53540499521867",
//         "53540499554635",
//       ],
//     },

//     /* EUR - OG - TRIPLE LIP PLUMPER EDITION REPULPEUR */
//     "540cce64-424b-4d7b-b8a9-d37f35126e58": {
//       main: "53583326806347",
//       subs: [
//         "53540501848395",
//         "53540501881163",
//         "53540501913931",
//         "53540501291339",
//         "53540501324107",
//         "53540499521867",
//         "53540499554635",
//       ],
//     },

//     /* INT - OG - TRIPLE LIP PLUMPER EDITION REPULPEUR */
//     "2924c0cf-005e-4b77-beb4-143ab43d88df": {
//       main: "53583326806347",
//       subs: [
//         "53540501848395",
//         "53540501881163",
//         "53540501913931",
//         "53540501291339",
//         "53540501324107",
//         "53540499521867",
//         "53540499554635",
//       ],
//     },
//   };
  
// const originalFetch = window.fetch;

// // 🧩 Interception FETCH (Shopify natif + Kaching)
// window.fetch = async function (resource, options = {}) {
//   try {
//     const isCartAdd =
//       typeof resource === "string" &&
//       (resource.includes("/cart/add") || resource.includes("/cart/add.js"));

//     if (isCartAdd && options && options.body) {
//       let body = options.body;
//       let parsedBody = {};

//       // 🔍 On lit le body (que ce soit JSON ou FormData)
//       if (typeof body === "string") {
//         try {
//           parsedBody = JSON.parse(body);
//         } catch {
//           console.warn("⚠️ Impossible de parser le body JSON d'origine");
//         }
//       } else if (body instanceof FormData) {
//         for (const [k, v] of body.entries()) parsedBody[k] = v;
//       }

//       // 🔧 Cas 1 : ajout groupé (Kaching ou Shopify items[])
//       if (parsedBody.items && Array.isArray(parsedBody.items)) {
//         // ✅ Utilise le même instanceId pour tout le groupe (main + subs)
//         const globalBundleId =
//           window._lastBundleInstanceId ||
//           "bundle-" + Math.random().toString(36).substring(2, 10);
//         window._lastBundleInstanceId = globalBundleId;
//         const instanceId = globalBundleId;

//         parsedBody.items.forEach((item) => {
//           const bundle = Object.values(bundleMap).find(
//             (b) =>
//               b.subs.includes(String(item.id)) || b.main === String(item.id)
//           );
//           if (bundle) {
//             item.properties = item.properties || {};
//             item.properties.bundle_instance_id = instanceId;
//             item.properties.bundle_parent = bundle.main;

//             // 🧩 Empêche Shopify de fusionner plusieurs lignes identiques
//             item.properties.bundle_unique_key = Math.random()
//               .toString(36)
//               .substring(2, 8);
//           }
//         });

//         // ✅ On remplace le body par du JSON propre
//         options.body = JSON.stringify(parsedBody);
//         options.headers = options.headers || {};
//         options.headers["Content-Type"] = "application/json";
//         console.log("✅ Bundle groupé tagué avant envoi :", instanceId);
//       }

//       // 🔧 Cas 2 : ajout simple (produit seul)
//       else if (parsedBody.id) {
//         const bundle = Object.values(bundleMap).find(
//           (b) =>
//             b.subs.includes(String(parsedBody.id)) ||
//             b.main === String(parsedBody.id)
//         );
//         if (bundle) {
//           // ✅ Utilise le même instanceId pour tout le groupe (main + subs)
//           const globalBundleId =
//             window._lastBundleInstanceId ||
//             "bundle-" + Math.random().toString(36).substring(2, 10);
//           window._lastBundleInstanceId = globalBundleId;
//           const instanceId = globalBundleId;

//           parsedBody.properties = parsedBody.properties || {};
//           parsedBody.properties.bundle_instance_id = instanceId;
//           parsedBody.properties.bundle_parent = bundle.main;

//           // 🧩 Empêche Shopify de fusionner la ligne unique
//           parsedBody.properties.bundle_unique_key = Math.random()
//             .toString(36)
//             .substring(2, 8);

//           // ✅ Conversion en JSON + header correct
//           options.body = JSON.stringify(parsedBody);
//           options.headers = options.headers || {};
//           options.headers["Content-Type"] = "application/json";
//           console.log("✅ Produit simple tagué avant envoi :", parsedBody.id, instanceId);
//         }
//       }
//     }
//   } catch (err) {
//     console.warn("⚠️ Erreur interception bundle :", err);
//   }

//   return originalFetch(resource, options);
// };



// function hideSubProductElements() {
//   const cartItems = document.querySelectorAll(".cart__item__bottom");
//   cartItems.forEach((item) => {
//     const removeBtn = item.querySelector(".cart__item__remove");
//     const quantityField = item.querySelector(".cart__item__quantity-field");
//     const minusBtn = item.querySelector(".cart__item__quantity-minus");
//     const plusBtn = item.querySelector(".cart__item__quantity-plus");

//     const id =
//       quantityField?.dataset.id?.split(":")[0] ||
//       removeBtn?.dataset.id?.split(":")[0];
//     if (!id) return;

//     const isMain = Object.values(bundleMap).some((b) => b.main === id);
//     const isSub = Object.values(bundleMap).some((b) => b.subs.includes(id));

// if (isSub) {
//   if (removeBtn) removeBtn.style.visibility = "hidden";
//   if (minusBtn) minusBtn.style.display = "none";
//   if (plusBtn) plusBtn.style.display = "none";
// if (quantityField) {
//   quantityField.style.display = ""; // visible
//   quantityField.setAttribute("readonly", "true"); // empêche la saisie
//   quantityField.style.pointerEvents = "none"; // bloque les clics sans griser
//   quantityField.style.opacity = "1"; // garde le look naturel
//   quantityField.style.cursor = "default"; // curseur normal
// }
//   console.log("🙈 Sous-produit : quantité visible, boutons masqués →", id);
// }
//  else if (isMain) {
//       if (removeBtn) removeBtn.style.visibility = "visible";
//       if (minusBtn) minusBtn.style.display = "";
//       if (plusBtn) plusBtn.style.display = "";
//       if (quantityField) quantityField.style.display = "";
//       console.log("🟢 Main product détecté :", id);
//     }
//   });
// }

// /* 💸 Cache le prix à 0€ des sous-produits */
// function hideBundleSubPrices() {
//   document.querySelectorAll(".cart__item").forEach((item) => {
//     const priceEl = item.querySelector(".cart__item__price, .cart-item__price");
//     const quantityField = item.querySelector(
//       ".cart__item__quantity-field, .cart-item__quantity"
//     );
//     const removeBtn = item.querySelector(
//       ".cart__item__remove, .cart-item__remove"
//     );
//     const id =
//       quantityField?.dataset.id?.split(":")[0] ||
//       removeBtn?.dataset.id?.split(":")[0];
//     if (!id || !priceEl) return;
//     const isSubProduct = Object.values(bundleMap).some((b) =>
//       b.subs.includes(id)
//     );
//     if (isSubProduct) {
//       priceEl.style.visibility = "hidden";
//       console.log("💸 Prix caché (sous-produit) :", id);
//     }
//   });
// }

// async function removeBundle(mainId) {
//   try {
//     console.log("🧹 Suppression du bundle principal :", mainId);

//     const res = await fetch("/cart.js");
//     const cart = await res.json();
//     const mainItem = cart.items.find(i => String(i.variant_id) === String(mainId));
//     if (!mainItem) return console.warn("⚠️ Main product introuvable :", mainId);

//     const instanceId = mainItem.properties?.bundle_instance_id;
//     if (!instanceId) return console.warn("⚠️ Pas de bundle_instance_id :", mainId);

//     // 🔍 On récupère tous les items orphelins ou liés au même bundle
//     const toRemove = cart.items.filter(i =>
//       i.properties?.bundle_instance_id === instanceId ||
//       i.properties?.bundle_parent === String(mainId)
//     );

//     if (toRemove.length === 0) {
//       console.warn("⚠️ Aucun produit trouvé à supprimer pour :", instanceId);
//       return;
//     }

//     // 🧩 Supprime tous les items trouvés
//     const updates = Object.fromEntries(toRemove.map(i => [i.variant_id, 0]));
//     await fetch("/cart/update.js", {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify({ updates }),
//     });

//     console.log("✅ Suppression côté serveur :", toRemove.map(i => i.title));

//     // 🧾 Vérifie définitivement
//     const final = await fetch("/cart.js").then(r => r.json());
//     console.log("📥 Panier final après suppression :", final.items.map(i => i.title));

//     document.dispatchEvent(new CustomEvent("cart:updated"));
//   } catch (err) {
//     console.error("❌ Erreur removeBundle amélioré :", err);
//   }
// }


// /* 🧩 Suppression groupée via data-bundle (HTML déjà enrichi dans le Liquid) */
// document.addEventListener("click", async (e) => {
//   const btn = e.target.closest("[data-item-remove]");
//   if (!btn) return;

//   const bundleId = btn.dataset.bundle;
//   if (!bundleId) return; // produit normal → Shopify gère tout seul
//   e.preventDefault();

//   console.log("🧹 Suppression bundle via data-bundle :", bundleId);

//   try {
//     // 1️⃣ Récupère le panier complet
//     const res = await fetch("/cart.js");
//     const cart = await res.json();

//     // 2️⃣ Filtre les items avec le même bundle_instance_id
//     const sameBundleItems = cart.items.filter(
//       (it) => it.properties?.bundle_instance_id === bundleId
//     );

//     if (sameBundleItems.length === 0) {
//       console.warn("⚠️ Aucun item trouvé avec bundle_instance_id =", bundleId);
//       return;
//     }

//     // 3️⃣ Supprime tous ces items d’un coup
//     const updates = Object.fromEntries(sameBundleItems.map((it) => [it.variant_id, 0]));
//     await fetch("/cart/update.js", {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify({ updates }),
//     });

//     console.log("✅ Bundle supprimé :", sameBundleItems.map((i) => i.title));

//     // 4️⃣ Rafraîchit ton drawer sans rechargement brutal
//     if (window.refreshCartDrawer) {
//       window.refreshCartDrawer();
//     } else {
//       const drawer = document.querySelector("#cartItemsHolder");
//       if (drawer) {
//         const html = await fetch("/cart?view=drawer").then((r) => r.text());
//         const doc = new DOMParser().parseFromString(html, "text/html");
//         const newContent = doc.querySelector("#cartItemsHolder");
//         if (newContent) drawer.innerHTML = newContent.innerHTML;
//       }
//     }

//   } catch (err) {
//     console.error("❌ Erreur suppression bundle :", err);
//   }
// });


// /* 👁️ Observe les interactions du drawer et rafraîchit l'affichage des bundles */
// function observeDrawer() {
//   const drawer = document.querySelector("#cartItemsHolder");
//   if (!drawer) return setTimeout(observeDrawer, 500);

//   hideSubProductElements();
//   hideBundleSubPrices();

//   // 💤 Ancienne gestion du clic sur "Retirer" désactivée (remplacée par data-bundle)

//   const observer = new MutationObserver(() => {
//     hideSubProductElements();
//     hideBundleSubPrices();
//   });

//   observer.observe(drawer, { childList: true, subtree: true });
//   console.log("👁️ Surveillance du drawer activée (live).");
// }

// /* 🚀 Initialisation robuste */
// function initBundles() {
//   try {
//     observeDrawer();
//     console.log("✅ Script bundles chargé (auto-run).");
//   } catch (err) {
//     console.error("❌ Erreur à l'initialisation du script bundles :", err);
//   }
// }

// if (document.readyState === "loading") {
//   document.addEventListener("DOMContentLoaded", initBundles);
// } else {
//   initBundles();
// }

// /* ----------------------------------------------------------
//    🧠 MODULE DEBUG GLOBAL — Chronologie + Export + UI + Clear
// ---------------------------------------------------------- */
// (function() {
//   const originalFetch = window.fetch;
//   window.bundleDebugLog = [];
//   window._bundleLastTime = Date.now();

//   // 🔧 Formateur d'heure lisible
//   function formatTime(d = new Date()) {
//     return d.toLocaleTimeString("fr-FR", { hour12: false }) +
//            "." + d.getMilliseconds().toString().padStart(3, "0");
//   }

//   // 🧩 Interception globale des requêtes Shopify /cart/
//   window.fetch = async function(resource, options = {}) {
//     const url = typeof resource === "string" ? resource : resource.url;
//     const isCartAction = url && url.includes("/cart/");
//     if (!isCartAction) return originalFetch(resource, options);

//     const now = Date.now();
//     const delta = ((now - window._bundleLastTime) / 1000).toFixed(3);
//     window._bundleLastTime = now;

//     const entry = {
//       timestamp_iso: new Date().toISOString(),
//       timestamp_local: formatTime(new Date()),
//       delta_since_last_s: delta,
//       url,
//       method: options?.method || "GET",
//       body: null,
//       response: null,
//       cartAfter: null,
//       status: null
//     };

//     try {
//       // 🧾 Body envoyé
//       if (options?.body) {
//         let body = options.body;
//         if (body instanceof FormData) {
//           const obj = {};
//           for (const [k, v] of body.entries()) obj[k] = v;
//           body = obj;
//         } else if (typeof body === "string") {
//           try { body = JSON.parse(body); } catch {}
//         }
//         entry.body = body;
//       }

//       // ⚙️ Exécution réelle
//       const response = await originalFetch(resource, options);
//       entry.status = response.status;

//       try {
//         entry.response = await response.clone().json();
//       } catch {
//         entry.response = await response.clone().text();
//       }

//       // 🔍 Vérification du panier
//       const verify = await fetch("/cart.js");
//       entry.cartAfter = await verify.json();

//       // 🧠 Enregistrement
//       window.bundleDebugLog.push(entry);

//       console.groupCollapsed(`🧩 [${entry.timestamp_local}] ${entry.method} ${url} (+${delta}s)`);
//       console.log("📦 Body :", entry.body);
//       console.log("📥 Réponse :", entry.response);
//       console.log("📄 Statut HTTP :", entry.status);
//       console.log("🛒 Panier après action :", entry.cartAfter?.items?.map(i => i.title));
//       console.groupEnd();

//     } catch (err) {
//       entry.error = err.message;
//       console.error("❌ Erreur debug fetch :", err);
//       window.bundleDebugLog.push(entry);
//     }

//     return originalFetch(resource, options);
//   };

//   /* ----------------------------------------------------------
//      🧾 Export et Réinitialisation
//   ---------------------------------------------------------- */
//   window.exportBundleDebug = function() {
//     const data = JSON.stringify(window.bundleDebugLog, null, 2);
//     const blob = new Blob([data], { type: "application/json" });
//     const url = URL.createObjectURL(blob);
//     const a = document.createElement("a");
//     a.href = url;
//     a.download = `bundle-debug-${new Date().toISOString().replace(/[:.]/g, "-")}.json`;
//     a.click();
//     console.log("📁 Export JSON effectué !");
//   };

//   window.resetBundleDebug = function() {
//     window.bundleDebugLog = [];
//     window._bundleLastTime = Date.now();
//     console.log("🧹 Log debug réinitialisé !");
//   };

//   /* ----------------------------------------------------------
//      🧹 Vidage complet du panier (avec reload)
//   ---------------------------------------------------------- */
//   window.clearCartCompletely = async function() {
//     console.log("🧹 Vidage complet du panier...");
//     const res = await fetch("/cart/clear.js", {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//     });

//     if (res.ok) {
//       console.log("✅ Panier vidé !");
//       if (window.Shopify && Shopify.theme && Shopify.theme.sections) {
//         document.dispatchEvent(new CustomEvent("cart:refresh"));
//       }
//       setTimeout(() => location.reload(), 500);
//     } else {
//       console.error("❌ Erreur clear cart :", res.status, res.statusText);
//     }
//   };

//   /* ----------------------------------------------------------
//      🖱️ UI — Boutons fixes Export + Clear
//   ---------------------------------------------------------- */
//   function createDebugButtons() {
//     const style = document.createElement("style");
//     style.textContent = `
//       #bundle-debug-ui {
//         position: fixed;
//         bottom: 10px;
//         right: 10px;
//         display: flex;
//         flex-direction: column;
//         gap: 6px;
//         z-index: 999999;
//       }
//       #bundle-debug-ui button {
//         background: #111;
//         color: #fff;
//         border: none;
//         padding: 8px 12px;
//         border-radius: 6px;
//         font-size: 13px;
//         font-family: monospace;
//         cursor: pointer;
//         opacity: 0.8;
//         transition: all 0.2s ease;
//       }
//       #bundle-debug-ui button:hover {
//         opacity: 1;
//         background: #333;
//       }
//     `;
//     document.head.appendChild(style);

//     const container = document.createElement("div");
//     container.id = "bundle-debug-ui";
//     container.innerHTML = `
//       <button id="btn-export-debug">🧾 Export Debug</button>
//       <button id="btn-reset-debug">🧠 Reset Log</button>
//       <button id="btn-clear-cart">🗑️ Clear Cart</button>
//     `;
//     document.body.appendChild(container);

//     document.getElementById("btn-export-debug").addEventListener("click", () => {
//       exportBundleDebug();
//     });

//     document.getElementById("btn-reset-debug").addEventListener("click", () => {
//       resetBundleDebug();
//     });

//     document.getElementById("btn-clear-cart").addEventListener("click", async () => {
//       await clearCartCompletely();
//     });
    
//   }

//   document.addEventListener("DOMContentLoaded", createDebugButtons);

//   console.log("✅ Mode debug FULL + UI initialisé (chronologie, export & clear).");
// })();
  






























  // // 🧹 Nettoyage automatique au chargement si des sous-produits orphelins existent
  // setTimeout(async () => {
  //   console.log("🧹 Vérification initiale des sous-produits orphelins...");
  //   const res = await fetch("/cart.js");
  //   const cart = await res.json();
  //   const variantIds = cart.items.map((i) => String(i.variant_id));

  //   const updates = {};
  //   for (const b of Object.values(bundleMap)) {
  //     for (const id of b.subs) {
  //       // si ce sous-produit est présent sans son main product → supprimer
  //       if (variantIds.includes(id) && !variantIds.includes(b.main)) {
  //         updates[id] = 0;
  //         console.log("🧹 Suppression immédiate sous-produit orphelin :", id);
  //       }
  //     }
  //   }

  //   if (Object.keys(updates).length > 0) {
  //     await fetch("/cart/update.js", {
  //       method: "POST",
  //       headers: { "Content-Type": "application/json" },
  //       body: JSON.stringify({ updates }),
  //     });
  //     console.log("✅ Panier nettoyé au chargement.");
  //     document.dispatchEvent(new CustomEvent("cart:updated"));
  //   }
  // }, 500);



  // END FUNCTION









  // // 🧩 Cache les boutons "Retirer" et sélecteurs de quantité pour les sous-produits
  // function hideSubProductElements() {
  //   const cartItems = document.querySelectorAll(".cart__item__bottom");

  //   cartItems.forEach((item) => {
  //     const removeBtn = item.querySelector(".cart__item__remove");
  //     const quantityField = item.querySelector(".cart__item__quantity-field");
  //     const minusBtn = item.querySelector(".cart__item__quantity-minus");
  //     const plusBtn = item.querySelector(".cart__item__quantity-plus");

  //     const id =
  //       quantityField?.dataset.id?.split(":")[0] ||
  //       removeBtn?.dataset.id?.split(":")[0];
  //     if (!id) return;

  //     const isMain = Object.values(bundleMap).some((b) => b.main === id);
  //     const isSub = Object.values(bundleMap).some((b) => b.subs.includes(id));

  //     // Sous-produit → cacher quantité + bouton "Retirer"
  //     if (isSub) {
  //       if (removeBtn) removeBtn.style.visibility = "hidden";
  //       if (minusBtn) minusBtn.style.display = "none";
  //       if (plusBtn) plusBtn.style.display = "none";
  //       if (quantityField) {
  //         quantityField.style.display = "none";
  //         quantityField.setAttribute("readonly", "true");
  //       }
  //       console.log("🙈 Éléments cachés pour le sous-produit :", id);
  //     }

  //     // Produit principal → garder visibles
  //     else if (isMain) {
  //       if (removeBtn) removeBtn.style.visibility = "visible";
  //       if (minusBtn) minusBtn.style.display = "";
  //       if (plusBtn) plusBtn.style.display = "";
  //       if (quantityField) quantityField.style.display = "";
  //       console.log("🟢 Éléments conservés pour le produit principal :", id);
  //     }
  //   });
  // }

  // let cleanupRunning = false;

  // // 🧹 Nettoyage intelligent — supprime uniquement les sous-produits orphelins
  // async function cleanupBundles() {
  //   if (cleanupRunning) {
  //     console.log("⏸️ Nettoyage déjà en cours, on ignore l'appel en double.");
  //     return;
  //   }

  //   cleanupRunning = true;
  //   try {
  //     const res = await fetch("/cart.js");
  //     const cart = await res.json();
  //     const variantIds = cart.items.map((i) => String(i.variant_id));

  //     // Liste des sous-produits protégés (encore liés à un main actif)
  //     const protectedSubs = new Set();
  //     for (const bundle of Object.values(bundleMap)) {
  //       if (variantIds.includes(bundle.main)) {
  //         bundle.subs.forEach((id) => protectedSubs.add(id));
  //       }
  //     }

  //     // Supprimer uniquement les sous-produits orphelins
  //     for (const [key, bundle] of Object.entries(bundleMap)) {
  //       if (!variantIds.includes(bundle.main)) {
  //         const toRemove = bundle.subs.filter(
  //           (id) => variantIds.includes(id) && !protectedSubs.has(id)
  //         );

  //         if (toRemove.length > 0) {
  //           console.log(
  //             "🧹 Suppression sous-produits orphelins :",
  //             key,
  //             toRemove
  //           );

  //           const updates = {};
  //           toRemove.forEach((id) => (updates[id] = 0));
  //           await fetch("/cart/update.js", {
  //             method: "POST",
  //             headers: { "Content-Type": "application/json" },
  //             body: JSON.stringify({ updates }),
  //           });

  //           // On attend un peu avant de rafraîchir le drawer pour éviter une boucle
  //           await new Promise((r) => setTimeout(r, 1000));
  //         }
  //       }
  //     }

  //     // 🧩 Rafraîchit le drawer proprement sans effet visuel ni boucle infinie
  //     const drawer = document.querySelector("#cartItemsHolder");
  //     if (drawer) {
  //       console.log("🔄 Rafraîchissement silencieux du drawer…");

  //       // 🔒 On désactive temporairement l'observer pour éviter un appel infini
  //       if (window.cartDrawerObserver) {
  //         window.cartDrawerObserver.disconnect();
  //       }

  //       const html = await fetch("/cart?view=drawer").then((r) => r.text());
  //       const doc = new DOMParser().parseFromString(html, "text/html");
  //       const newContent = doc.querySelector("#cartItemsHolder");

  //       if (newContent) {
  //         drawer.innerHTML = newContent.innerHTML;
  //         console.log("✅ Drawer mis à jour proprement.");
  //       }

  //       // ⏳ On réactive l'observer après un court délai
  //       setTimeout(() => {
  //         observeDrawer();
  //       }, 300);
  //     }
  //   } catch (err) {
  //     console.error("⚠️ Erreur cleanupBundles:", err);
  //   } finally {
  //     // Libère le verrou après 2 secondes
  //     setTimeout(() => (cleanupRunning = false), 2000);
  //   }
  // }

  // // 👁️ Observe le drawer pour appliquer automatiquement les changements
  // function observeDrawer() {
  //   const drawer = document.querySelector("#cartItemsHolder");
  //   if (!drawer) return setTimeout(observeDrawer, 500);

  //   hideSubProductElements();

  //   // 👁️ Sauvegarde l’observateur dans une variable globale (pour le déconnecter si besoin)
  //   const observer = new MutationObserver(() => {
  //     hideSubProductElements();
  //     cleanupBundles();
  //   });

  //   // Stockage global pour éviter plusieurs observers en parallèle
  //   if (window.cartDrawerObserver) {
  //     window.cartDrawerObserver.disconnect();
  //   }
  //   window.cartDrawerObserver = observer;

  //   observer.observe(drawer, { childList: true, subtree: true });

  //   console.log("👁️ Surveillance du drawer activée.");
  // }

  // observeDrawer();

  // // 🧠 Ajout d'écouteurs globaux pour fiabiliser le nettoyage des bundles
  // document.addEventListener("cart:updated", () => {
  //   console.log("🧩 cart:updated → vérification des bundles");
  //   cleanupBundles();
  // });

  // document.addEventListener("cart:drawer:updated", () => {
  //   console.log("🧩 cart:drawer:updated → vérification des bundles");
  //   cleanupBundles();
  // });

  // // Option de secours : check automatique toutes les 5 secondes
  // setInterval(() => {
  //   cleanupBundles();
  // }, 5000);

  // // 💸 Masque les prix des sous-produits des bundles
  // function hideBundleSubPrices() {
  //   document.querySelectorAll(".cart__item").forEach((item) => {
  //     const priceEl = item.querySelector(
  //       ".cart__item__price, .cart-item__price"
  //     );
  //     const quantityField = item.querySelector(
  //       ".cart__item__quantity-field, .cart-item__quantity"
  //     );
  //     const removeBtn = item.querySelector(
  //       ".cart__item__remove, .cart-item__remove"
  //     );

  //     const id =
  //       quantityField?.dataset.id?.split(":")[0] ||
  //       removeBtn?.dataset.id?.split(":")[0];
  //     if (!id || !priceEl) return;

  //     const isSubProduct = Object.values(bundleMap).some((b) =>
  //       b.subs.includes(id)
  //     );

  //     if (isSubProduct) {
  //       priceEl.style.visibility = "hidden";
  //       console.log("💸 Prix caché pour sous-produit :", id);
  //     }
  //   });
  // }

  // // 🔁 Exécution automatique à chaque changement du panier
  // document.addEventListener("DOMContentLoaded", hideBundleSubPrices);
  // document.addEventListener("cart:updated", hideBundleSubPrices);
  // document.addEventListener("cart:drawer:opened", hideBundleSubPrices);

  // // 👁️ Surveillance permanente du drawer
  // function observeDrawerPrices() {
  //   const drawer = document.querySelector(
  //     "#CartDrawer, .cart-drawer, #cartItemsHolder"
  //   );
  //   if (!drawer) return setTimeout(observeDrawerPrices, 500);

  //   const observer = new MutationObserver(() => hideBundleSubPrices());
  //   observer.observe(drawer, { childList: true, subtree: true });

  //   console.log("👁️ Surveillance du drawer activée (prix sous-produits).");
  // }
  // observeDrawerPrices();




    // SNOWFALL EFFECT //

  const NUMBER_OF_SNOWFLAKES = 150;
const MAX_SNOWFLAKE_SIZE = 5;
const MAX_SNOWFLAKE_SPEED = 0.5;
const SNOWFLAKE_COLOUR = '#ddd';
const snowflakes = [];

const canvas = document.createElement('canvas');
canvas.style.position = 'absolute';
canvas.style.pointerEvents = 'none';
canvas.style.top = '0px';
canvas.width = window.innerWidth;
canvas.height = window.innerHeight;
document.body.appendChild(canvas);

const ctx = canvas.getContext('2d');


const createSnowflake = () => ({
    x: Math.random() * canvas.width,
    y: Math.random() * canvas.height,
    radius: Math.floor(Math.random() * MAX_SNOWFLAKE_SIZE) + 1,
    color: SNOWFLAKE_COLOUR,
    speed: Math.random() * MAX_SNOWFLAKE_SPEED + 1,
    sway: Math.random() - 0.5 // next
});

const drawSnowflake = snowflake => {
    ctx.beginPath();
    ctx.arc(snowflake.x, snowflake.y, snowflake.radius, 0, Math.PI * 2);
    ctx.fillStyle = snowflake.color;
    ctx.fill();
    ctx.closePath();
}

const updateSnowflake = snowflake => {
    snowflake.y += snowflake.speed;
    snowflake.x += snowflake.sway; // next
    if (snowflake.y > canvas.height) {
        Object.assign(snowflake, createSnowflake());
    }
}

const animate = () => {
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    snowflakes.forEach(snowflake => {
        updateSnowflake(snowflake);
        drawSnowflake(snowflake);
    });

    requestAnimationFrame(animate);
}

for (let i = 0; i < NUMBER_OF_SNOWFLAKES; i++) {
    snowflakes.push(createSnowflake());
}

window.addEventListener('resize', () => {
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;
});

window.addEventListener('scroll', () => {
    canvas.style.top = `${window.scrollY}px`;
});

// setInterval(animate, 15);
animate()
  

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();























// console.log("✅ custom.js chargé correctement");
  //   document.addEventListener('DOMContentLoaded', () => {
  //   const productIdsToRemove = []; // produits à supprimer
  //   const removeDelay = 400;
  //   const retryDelay = 400;
  //   const maxAttempts = 5;

  //   // --- 1. Masque les produits dans le DOM
  //   function hideFreeProducts() {
  //     let found = false;
  //     document.querySelectorAll('.cart__item, [data-cart-item]').forEach(item => {
  //       const data = item.dataset.item || '';
  //       if (productIdsToRemove.some(id => data.includes(id.toString()))) {
  //         item.style.opacity = '0';
  //         item.style.pointerEvents = 'none';
  //         item.style.height = '0';
  //         item.style.margin = '0';
  //         item.style.padding = '0';
  //         item.style.overflow = 'hidden';
  //         found = true;
  //       }
  //     });
  //     if (found) console.log(' Produit technique masqué automatiquement');
  //   }

  //   // --- 2. Supprime via /cart/change.js
  //   async function removeProductsSafely() {
  //     let attempts = 0;

  //     async function checkAndRemove() {
  //       try {
  //         const res = await fetch('/cart.js');
  //         const cart = await res.json();

  //         // Filtre les produits selon leur product_id
  //         const productsToRemove = cart.items.filter(i =>
  //           productIdsToRemove.includes(i.product_id)
  //         );
  //         if (!productsToRemove.length) return true;

  //         // Supprime-les un par un
  //         for (const product of productsToRemove) {
  //           console.log(` Suppression du produit ${product.product_id} (${product.title})`);
  //           await fetch('/cart/change.js', {
  //             method: 'POST',
  //             headers: { 'Content-Type': 'application/json' },
  //             body: JSON.stringify({ id: product.key, quantity: 0 })
  //           });
  //         }

  //         hideFreeProducts();
  //         return false;
  //       } catch (err) {
  //         console.error(' Erreur suppression produit technique:', err);
  //         return false;
  //       }
  //     }

  //     const interval = setInterval(async () => {
  //       const done = await checkAndRemove();
  //       attempts++;
  //       if (done || attempts >= maxAttempts) clearInterval(interval);
  //     }, retryDelay);
  //   }

  //   // --- 3. Observer les changements du mini-panier
  //   const observer = new MutationObserver(() => hideFreeProducts());
  //   observer.observe(document.body, { childList: true, subtree: true });

  //   // --- 4. Surveille les ajouts au panier
  //   document.addEventListener('click', e => {
  //     if (e.target.closest('form[action="/cart/add"]') || e.target.closest('[data-add-to-cart]')) {
  //       hideFreeProducts();
  //       setTimeout(removeProductsSafely, removeDelay);
  //     }
  //   });

  //   // --- 5. Vérifie au chargement
  //   hideFreeProducts();
  //   setTimeout(removeProductsSafely, 1000);
  // });

  // document.addEventListener('click', function(e) {
  //   const link = e.target.closest('.siblings a[href]');
  //   if (!link) return;
  //   e.preventDefault();
  //   window.location.href = link.getAttribute('href'); // recharge complet
  // });

  // document.addEventListener('DOMContentLoaded', () => {
  //   const variantToRemove = 53546881712459; // ID du produit factice (Triple Lip Plumper)
  //   const removeDelay = 400; // délai avant suppression réelle
  //   const retryDelay = 400;
  //   const maxAttempts = 5;

  //   // --- 1. Fonction qui masque le produit dans le DOM
  //   function hideFreeProduct() {
  //     let found = false;
  //     document.querySelectorAll('.cart__item, [data-cart-item]').forEach(item => {
  //       const data = item.dataset.item || '';
  //       if (data.includes(variantToRemove.toString())) {
  //         item.style.opacity = '0';
  //         item.style.pointerEvents = 'none';
  //         item.style.height = '0';
  //         item.style.margin = '0';
  //         item.style.padding = '0';
  //         item.style.overflow = 'hidden';
  //         found = true;
  //       }
  //     });
  //     if (found) console.log(' Produit 0€ masqué automatiquement');
  //   }

  //   // --- 2. Suppression réelle via /cart/change.js
  //   async function removeProductSafely() {
  //     let attempts = 0;
  //     async function checkAndRemove() {
  //       try {
  //         const res = await fetch('/cart.js');
  //         const cart = await res.json();
  //         const productToRemove = cart.items.find(i => i.variant_id === variantToRemove);
  //         if (!productToRemove) return true;

  //         await fetch('/cart/change.js', {
  //           method: 'POST',
  //           headers: { 'Content-Type': 'application/json' },
  //           body: JSON.stringify({ id: productToRemove.key, quantity: 0 })
  //         });

  //         hideFreeProduct();
  //         return false;
  //       } catch (err) {
  //         console.error('Erreur suppression produit 0€:', err);
  //         return false;
  //       }
  //     }

  //     const interval = setInterval(async () => {
  //       const done = await checkAndRemove();
  //       attempts++;
  //       if (done || attempts >= maxAttempts) clearInterval(interval);
  //     }, retryDelay);
  //   }

  //   // --- 3. MutationObserver : surveille le DOM du mini-panier
  //   const observer = new MutationObserver(() => {
  //     hideFreeProduct();
  //   });

  //   observer.observe(document.body, { childList: true, subtree: true });

  //   // --- 4. Surveille les clics sur les boutons “ajouter au panier”
  //   document.addEventListener('click', e => {
  //     if (e.target.closest('form[action="/cart/add"]') || e.target.closest('[data-add-to-cart]')) {
  //       hideFreeProduct(); // essaye immédiatement
  //       setTimeout(removeProductSafely, removeDelay);
  //     }
  //   });

  //   // --- 5. Vérifie au chargement
  //   hideFreeProduct();
  //   setTimeout(removeProductSafely, 1000);
  // });

  // document.addEventListener('DOMContentLoaded', () => {
  //   const hasKaching = document.querySelector('.kaching-bundles__block');
  //   const submitHolder = document.querySelector('.product__submit__holder.product__submit__holder--spb.product__submit__holder--notification');

  //   if (hasKaching && submitHolder) {
  //     const margin = window.innerWidth < 1200 ? '-100px' : '-40px';
  //     submitHolder.style.marginTop = margin;
  //     console.log(` Kaching détecté → marge ajustée (${margin})`);
  //   }
  // });